// Import the URL module
import { URL } from 'url';

/**
 * Extracts domain name from a given URL.
 *
 * @param {string} url - The full URL from which the domain name needs to be extracted.
 * @returns {string} - The domain name.
 */
export function domainNameFromUrl(url: string): string {
  try {
    // The `URL` constructor parses the input URL
    const urlObject = new URL(url);

    // Extract the hostname from the URL
    const domain = urlObject.hostname;

    return domain;
  } catch (error: any) {
    // If there's an error in parsing the URL, handle it (e.g., log it or throw an exception)
    throw new Error(`Invalid URL provided: ${error.message}`);
  }
}

export default domainNameFromUrl;

// // Example usage:
// const fullUrl = 'http://www.example.com/page';
// const domain = domainNameFromUrl(fullUrl);
// console.log(domain); // Output: "www.example.com"
